export default __webpack_public_path__ + "static/media/790246046562254918.b4aef27e.png";